/**
 * 门户端-菜单
 */

import request from "@/utils/request";

/**
 * 查询所有菜单
 */
export function getList(params) {
  return request({
    url: "/api/v1/portal/menu",
    method: "get",
    params,
  });
}

export default {
  getList,
};
